import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { ARTICLE_GROUP_IMAGES_QUERY } from './articleGroupImages.query';
import { kmsClient } from 'api';
import { ArticleGroupImagesQuery, ArticleGroupImagesQueryVariables } from './__generated__/ArticleGroupImagesQuery';

export const useArticleGroupImagesLazyQuery = (variables: ArticleGroupImagesQueryVariables) => {
  return useLazyQuery<ArticleGroupImagesQuery>(ARTICLE_GROUP_IMAGES_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};

export const useArticleGroupImagesQuery = (variables: ArticleGroupImagesQueryVariables) => {
  return useQuery<ArticleGroupImagesQuery>(ARTICLE_GROUP_IMAGES_QUERY, {
    variables,
    client: kmsClient,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only'
  });
};
